<template>
    <div class="row mt-2" ref="div">
        <div class="col-6 upload-box">
            <div class="container-file-upload"
                @drop="handleFileDrop"
                @dragover="handleDragOver"
                @dragleave="fileDragOut"
                v-bind:style="{ 'background-color': color }">
                <i class="fa-solid fa-upload colored-icon mb-4 upload-icon"></i>
                <p class="mb-2">{{ __('forms.Person.permission_tabs.documents.dragDrop') }}</p>
                <div class="upload-btn-wrapper">
                    <button class="btn btn--blue align-center">
                        {{ __('forms.Person.permission_tabs.documents.selectFilefromPC') }}
                    </button>
                    <input type="file" id="files" ref="files" @change="handleFileInput" multiple>
                </div>
            </div>
        </div>

        <div class="col-6">
            <p class="text-primary">
                {{ __('forms.Person.permission_tabs.documents.targetFolder') }}:
                <span class="text-voice-value">{{ name_folder }}</span>
            </p>
            <div v-if="files.length > 0">               
                <div class="table-responsive mt-2">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="one-action-col">{{ __('misc.actions') }}</th>
                                <th>{{ __('forms.Person.permission_tabs.documents.fileName') }}</th>
                                <th>{{ __('forms.Person.permission_tabs.documents.fileSize') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(file,index) in files">
                                <td class="one-action-col">
                                    <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1"
                                        href="#" type="button" @click="rmFileForm(file,index)" >
                                        <i class="fa fa-trash"></i>
                                    </button>    
                                </td>
                                <td>
                                    {{ file.name | vue_truncate(30) }}
                                </td>                               
                                <td>
                                {{ file.size /1000 }} kb
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-else>
                <div class="mt-2">
                    <i class="fa-solid fa-circle-exclamation colored-icon"></i>
                    <span class="text-voice-value">{{ __('forms.Person.permission_tabs.documents.noFileQueued') }}</span>
                </div>
            </div>
        </div>

        <div class="col-12">
            <button class="btn btn--green float-right" type="button" @click="submitFiles">
                {{ __('forms.Person.permission_tabs.documents.uploadFile') }}
            </button>
        </div>

    </div>
</template>

<style>
    .container-file-upload {
        width:400px;
        text-align: center;
        padding:50px;
        border-radius:10px;
    }

    .upload-icon {
        font-size: 60px;
    }

    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }

    .upload-btn {
        border: 2px solid #007bff;
        color: white;
        background-color: #007bff;
        padding: 8px 20px;
        border-radius: 5px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;

    }

    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }

    .upload-box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    }
</style>

<script>
export default {
    props: {
        model_id :{
            type: Number,
            required: true
        },
        post_url :{
            type: String,
            required: true
        },
        model :{
            type: String,
            required: true
        },
        name_folder :{
            type: String,
            required: true
        },
        module_name :{
            type: String,
            required: true
        },
        share :{
            type: Number,
            required: true
        },
        folder :{
            type: Number,
            required: false,
            default:null
        },
        category :{
            type: String,
            required: false,
            default:null
        },
    },

    data () {
        return {
            files: [],
            color: 'white',
        }
    },

    mounted () {

    },

    methods: {
        rmFileForm(index){
            this.files.splice(index, 1);
        },
        submitFiles(){
            /*
              Initialize the form data
            */
            let formData = new FormData();

            /*
              Iteate over any file sent over appending the files
              to the form data.
            */
            for( var i = 0; i < this.files.length; i++ ){
                let file = this.files[i];

                formData.append('files[' + i + ']', file);
            }
            /**
             * add hidden values
             *  <input type="hidden" value="modelId" :value="model_id">
             <input type="hidden" value="model" :value="model">
             <input type="hidden" value="folder" :value="folder">
             <input type="hidden" value="share" :value="share">
             */
                formData.append("modelId",this.model_id);
                formData.append("model",this.model);
                formData.append("folder",this.folder);
                formData.append("share",this.share);
                formData.append("module",this.module_name);
                formData.append("category",this.category);

            /*
              Make the request to the POST /multiple-files URL
            */
            axios.post( this.post_url,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function(response){

              let txt = "<label>"+response.data.newInsert+" nuovi file inseriti "+"</label>";
              if(response.data.omitted > 0){
                  txt+="<br><label>"+response.data.omitted+" file già presenti non caricati</label>";
              }

              Vue.swal.fire({
                title: 'Files inseriti con successo',
                html: txt,
              });

                if(response.data.closePopup){

                    app.__vue__.$refs.vue_popup.active = false;
                    app.__vue__.$refs.document_sharing.readFolder(response.data.folder);

                }
                else{
                    //add normal file, reload attachment page with url returned from server
                    
                    app.__vue__.$refs.vue_popup.toggle("Allegati",response.data.urlHomeAttachments);
                }
            })
                .catch(function(error){
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    }
                })
            .finally(function (){

            });

            //call sync function
            if(this.share) {
                app.__vue__.$refs.document_sharing.readFolder(this.folder);
            }

        },

        cleanDuplicates(){ 
            
            var obj = {};

            for ( var i=0, len= this.files.length; i < len; i++ )
                obj[this.files[i]['name']] = this.files[i];

            let clean = new Array();
            for ( var key in obj )
                clean.push(obj[key]);
 
            this.files = clean;
        },
        handleFileDrop(e) {
            e.preventDefault();
            let droppedFiles = e.dataTransfer.files;

            if(!droppedFiles) return;
         
            for (var i = 0, l = droppedFiles.length; i < l; i++) {
                this.files.push(droppedFiles[i]);

            }
            this.cleanDuplicates();
        },
        handleFileInput(e) {

           //this.$refs.files.files;
            for (var i = 0; i < this.$refs.files.files.length; i++) {
                // get item
                    this.files.push(this.$refs.files.files[i]);
            }
            this.cleanDuplicates();

        },
        removeFile(fileKey){
            //this.files.splice(fileKey, 1)
            this.files = [];
        },
        fileDragIn(){
            this.color = "#f4f4f4"; // Cambia il colore quando un file è sopra l'area di drag
        },

        fileDragOut(){
            this.color = "white"; // Resetta il colore quando il file lascia l'area di drag
        },

        handleDragOver(e) {
        e.preventDefault(); // Questo impedisce al browser di aprire il file
        this.color = "#f4f4f4"; // Opzionale: cambia il colore durante il drag over
    },

    }
}

Vue.filter('vue_truncate', function(value, maxLength) {
    if (!value) return '';
    maxLength = maxLength || 30;
    return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
});
</script>

